import "./GroupRedact.scss";

import GroupCard from "../card/GroupCard";
import PhonesListContainer from "../../../containers/phone/PhonesListContainer";
import React from "react";
import RedactIcon from "../../../assets/redact.png";
import RemoveIcon from "../../../assets/remove.png";

interface Props {
  index: number;
  group: App.Group;
  onTryRedact: () => void;
  onTryDelete: () => void;
  onTryAddPhone: () => void;
  onStartMove: (index: number) => void;
  onMouseEnter: (index: number) => void;
  onEndMove: () => void;
  updateCurrentGroup: (group: App.Group) => void;
}
interface State {}

class GroupRedact extends React.Component<Props, State> {
  private handleDragStart() {
    this.props.onStartMove(this.props.index);
  }
  private handleDragEnter() {
    this.props.onMouseEnter(this.props.index);
  }
  private handleDragEnd() {
    this.props.onEndMove();
  }

  public render() {
    return (
      <div
        className="group-redact"
        draggable={true}
        onDragStart={this.handleDragStart.bind(this)}
        onDragEnter={this.handleDragEnter.bind(this)}
        onDragEnd={this.handleDragEnd.bind(this)}
      >
        <GroupCard group={this.props.group} active={false}>
          <div className="buttons">
            <img src={RedactIcon} alt="R" onClick={this.props.onTryRedact} />
            <img src={RemoveIcon} alt="D" onClick={this.props.onTryDelete} />
          </div>
        </GroupCard>
        <PhonesListContainer
          group={this.props.group.id}
          phones={this.props.group.phones}
          redact
        />
      </div>
    );
  }
}
export default GroupRedact;
